module.exports = __webpack_public_path__ + "img/tb1039-3-1974.prt.7baf77b3.jpg";